import { SettingsJob } from "../data/settings/SettingsJob";
import { IJobListResponse } from "../interfaces/Job";
import { useAppQuery } from "./useAppQuery";

interface Props {
  name: string;
}

export const useGetListJob = ({ name }: Props) => {
  const { data } = useAppQuery<IJobListResponse, Error, SettingsJob[]>("/JobDefinition/list", {
    config: {
      params: {
        searchText: name,
        pageSize: 50
      }
    },
    select: (data) => {
      return data?.jobDefinitions?.data.map((j) => new SettingsJob(j))
    }
  });
  return { jobList: data };
};
